<template>
  <div class="qyjs_box">
    <div class="qyjs_box_bottom">
      <!-- <img src="../../assets/成考1.jpg" alt="" class="img" usemap="#Map" /> -->
	  <!-- <map name="Map">
		<area shape="rect" coords="0,0,100,100" href="#" @click="handleClick()" />
		<area shape="rect" coords="100,100,500,500" href="#" @click="handleClick1()" />
	  </map> -->
	  
	  <img src="../../assets/成考1.jpg" alt="" class="img"/>
    </div>
  </div>
</template>

<script>
import { xuemengintro } from "@/api/intoxuemeng";
export default {
  data() {
    return {
      jieshao: {},
      intro: "",
    };
  },
  created() {
    // this.creat();
  },
  methods: {
   handleClick(){
	   console.log('点击了图片热区')
   },
   handleClick1(){
	  console.log('点击了图片热区1111111111') 
   }
  },
};
</script>

<style lang="scss" scoped>
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.qyjs_box {
  // width: 1400px;
  // height: 100px;
  // background-color: #9b0e12;
  // margin: 0 auto;
  //
  .qyjs_box_top {
    margin-top: 50px;
    margin-bottom: 30px;
    display: flex;
    height: 280px;
    .qyjs_box_top_left {
      width: 270px;
      height: 100%;

      .qyjs_box_top_left_top {
        height: 60px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        .since {
          font-size: 36px;
          height: 30px;
          color: #979ea7;
          margin-bottom: 14px;
        }
        .build {
          font-size: 14px;
          color: #313a4c;
        }
      }

      .qyjs_box_top_left_buttom {
        display: flex;
        margin-top: 32px;
        font-size: 12px;

        .qyjs_box_top_left_buttom_left {
          height: 75px;
          width: 115px;
          text-align: center;

          .qyjs_box_top_left_buttom_left_span {
            font-size: 42px;
            font-weight: 600;
            color: #9b0e12;
          }
          .qyjs_box_top_left_buttom_left_div {
            font-size: 12px;
          }
        }

        .qyjs_box_top_left_buttom_right {
          height: 75px;
          width: 115px;
          text-align: center;
          margin-left: 30px;

          .qyjs_box_top_left_buttom_left_span {
            font-size: 42px;
            font-weight: 600;
            color: #9b0e12;
          }
          .qyjs_box_top_left_buttom_left_div {
            font-size: 12px;
          }
        }
      }
    }
    .qyjs_box_top_right {
      margin-left: 90px;
      width: 1025px;
      // width: ;
      .qyjs_box_top_right_top {
        font-weight: 600;
        font-size: 28px;
        margin-bottom: 43px;
        color: #2f384a;
      }
      .qyjs_box_top_right_top_bottom {
        font-size: 18px;
        color: #30394b;
        line-height: 32px;
      }
    }
  }

  .qyjs_box_bottom {
    width: 1400px;
	margin-top: 30px;
    // background-color: #9b0e12;
    margin-bottom: 30px;
  }
}
</style>